var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "search-container" }, [
    _vm.showSearchBar
      ? _c(
          "div",
          { staticClass: "search-component" },
          [
            _vm.$root.isDesktop
              ? _c("search-component", {
                  staticClass: "search-box",
                  attrs: {
                    placeholder: "Search all fields",
                    "search-filter": _vm.searchText,
                    "handle-search-on-type": true,
                  },
                  on: { onSearch: _vm.handleFilterOrSearch },
                })
              : _vm._e(),
          ],
          1
        )
      : _vm._e(),
    _vm.showGridFilter
      ? _c(
          "div",
          { staticClass: "filter-container" },
          [
            _vm.gridApi
              ? _c("grid-filter-manager", {
                  attrs: {
                    "grid-api": _vm.gridApi,
                    "get-search-text": function () {
                      return _vm.searchText
                    },
                    "set-search-text": function (v) {
                      _vm.searchText = v
                      _vm.refreshServerSide()
                    },
                    "grid-url": _vm.gridUrl,
                  },
                  on: { "default-filter-loaded": _vm.filterHasLoaded },
                })
              : _vm._e(),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }